import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import ResidentService from '@/io/resident.js';
import RepairOrderService from '@/io/repair_order.js';

export default new Vuex.Store({
  state: {
    userInfo: null,
    menuList: null,
    redirectUrl: null,
    community: null,
    isNewResident: false,
    isNewRepair: false
  },
  mutations: {
    setUserInfo(state, params) {
      state.userInfo = params;
    },
    setMenuList(state, params) {
      state.menuList = params;
    },
    setRedirectUrl(state, params) {
      state.redirectUrl = params;
    },
    setCommunity(state, params) {
      state.community = params;
    },
    setIsNewRisident(state, params) {
      state.isNewResident = params;
    },
    setIsNewRepair(state, params) {
      state.isNewRepair = params;
    },
  },
  actions: {
    isNewResident({ commit }) {
      ResidentService.isNew().then(res => {
        commit('setIsNewRisident', res.tips);
      }).catch(err => { });
    },
    isNewRepair({ commit }) {
      RepairOrderService.isNew().then(res => {
        commit('setIsNewRepair', res.tips);
      }).catch(err => {});
    }
  },
  modules: {

  }
});
